/**
 * Marketplace logo URLs via Google Favicon V2 API.
 * Returns the actual brand icon (app icon / favicon) at 128×128px.
 * Works in any browser with internet access.
 *
 * URL format:
 * https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://{domain}&size=128
 */

function gFavicon(domain: string): string {
  return `https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://${domain}&size=128`;
}

export const MARKETPLACE_LOGOS: Record<string, string> = {
  ml:         gFavicon('mercadolivre.com.br'),
  shopee:     gFavicon('shopee.com.br'),
  amazon:     gFavicon('amazon.com.br'),
  magalu:     gFavicon('magazineluiza.com.br'),
  shein:      gFavicon('shein.com'),
  tiktok:     gFavicon('tiktok.com'),
  aliexpress: gFavicon('aliexpress.com'),
  casasbahia: gFavicon('casasbahia.com.br'),
  pontofrio:  gFavicon('pontofrio.com.br'),
  extra:      gFavicon('extra.com.br'),
  leroy:      gFavicon('leroymerlin.com.br'),
  carrefour:  gFavicon('carrefour.com.br'),
  netshoes:   gFavicon('netshoes.com.br'),
  dafiti:     gFavicon('dafiti.com.br'),
};
